export const state = {
  pagination: {
    grid: {
      start: 0,
      limit: 0,
    },
    table: {
      start: 0,
      limit: -1,
    }
  }
}


export const getters = {
}


export const mutations = {
  // pagination GRID
  setPaginationGridStart: (state, data) => {
    state.pagination.grid.start = data;
  },
  setPaginationGridLimit: (state, data) => {
    state.pagination.grid.limit = data;
  },
  // pagination TABLE
  setPaginationTableStart: (state, data) => {
    state.pagination.table.start = data;
  },
  setPaginationTableLimit: (state, data) => {
    state.pagination.table.limit = data;
  },
}


export const actions = {
}

